/**
 * MakeLoveLocks — Scroll Animations & Header Behavior
 */

(function () {
  "use strict";

  // Intersection Observer for fade-up animations
  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          fadeObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -50px 0px",
    },
  );

  // Observe all animated elements
  document.querySelectorAll(".mll-fade-up, .mll-stagger").forEach((el) => {
    fadeObserver.observe(el);
  });

  // Transparent header on hero sections
  // Use .header-wrapper (always present) instead of .section-header
  // (Shopify strips section-group wrappers on non-English locales)
  const headerWrapper = document.querySelector(".header-wrapper");
  const hero = document.querySelector(".mll-hero");

  if (headerWrapper && hero) {
    const totalHeaderHeight = headerWrapper.offsetHeight;

    function updateHeader() {
      const scrollY = window.scrollY || window.pageYOffset;
      const heroBottom = hero.offsetHeight - totalHeaderHeight;

      if (scrollY > heroBottom) {
        headerWrapper.classList.add("mll-header--solid");
        headerWrapper.classList.remove("mll-header--transparent");
      } else {
        headerWrapper.classList.add("mll-header--transparent");
        headerWrapper.classList.remove("mll-header--solid");
      }
    }

    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });
  }
})();
